// import Cta from '@/components/global/Cta';

import Block from "@/components/elements/Block";
import { InternalCTALink } from "@/components/elements/WebLink";

const EmptyState = ({ block, position }) => {
    const { empty_state, settings } = block;

  return (
    <Block
      name="empty_state"
      settings={settings}
      className="flex flex-col items-center text-center"
    >
      {/* BL-472: an h1, not a div. This is the only heading on /cart when the
          cart is empty — CartContent supplies one when there are line items,
          so the page had no h1 at all in exactly the state a first-time
          visitor lands in. Styling is unchanged. */}
      <h1 className="font-worksans text-2xl text-primary">
        {empty_state.title}
      </h1>

      <InternalCTALink
        label={empty_state.link.title}
        link={empty_state.link.href}
        showIcon={false}
      />
    </Block>
  );
};

export default EmptyState;
